module.exports = __webpack_public_path__ + "fonts/sourcesansproblack.31a4c46a.ttf";